import { FC } from 'react';
import CopyTextButton from 'v3/common/components/CopyTextButton';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const oneIndentation = ' ';

const Finvasia: FC = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h2>Finvasia API Setup in 8 Steps</h2>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <p>
            Visit the <b>Finvasia</b> page and proceed with the <b>login</b> process.
            <br />
            <b>
              <a href="https://trade.shoonya.com/#/" target="blank" title="Finvasia Login">
                https://trade.shoonya.com/#/
              </a>
            </b>
          </p>
          <img src="/images/broker_setup_guide/finvasia/step_1.png" alt="Create New App" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <p>
            Select
            {oneIndentation}
            <b>Profile ID </b>section at the top-right corner.
          </p>
          <img src="/images/broker_setup_guide/finvasia/step_2.png" alt="Create New App" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <p>
            Click the
            {oneIndentation}
            <b>API KEY</b> button on the page.
          </p>
          <img src="/images/broker_setup_guide/finvasia/step_3.png" alt="Create New App" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <p>
            Complete the required details below by filling in the <b>URL</b> and <b>Primary IP Address</b>{' '}
            boxes.
          </p>

          <img src="/images/broker_setup_guide/finvasia/step_4.png" alt="Quantman App details" />

          <div className="stepper__form">
            <div className="stepper__form-group">
              <h6>URL:</h6>
              <span>https://www.quantman.trade/auth/finvasia/callback?client_id=xxxxxxx</span>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input
                    type="text"
                    placeholder="https://www.quantman.trade/auth/finvasia/callback?client_id=xxxxxxx"
                    disabled
                  />
                </span>
                <CopyTextButton text="https://www.quantman.trade/auth/finvasia/callback?client_id=xxxxxxx" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Primary IP Address</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Contact Support Team" disabled />
                </span>
                <CopyTextButton text="123.456.789" disabled />
              </div>
            </div>
          </div>
        </div>
      </li>

      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <p>
            Please
            {oneIndentation}
            click on <b>Update</b> to save the changes.
          </p>
          <img src="/images/broker_setup_guide/finvasia/step_5.png" alt="Create New App" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="6">
        <div className="stepper_content">
          <p>
            Copy the <b>Secret Code</b> and return to the QuantMan website.
          </p>
        </div>
      </li>
      <li className="stepper_item" data-stepper="7">
        <div className="stepper_content">
          <p className="">
            Click the <b>Back</b> to access the login section and input your <b>User ID</b>.
          </p>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="Finvasia fill form" />
        </div>
      </li>
      <li className="stepper_item" data-stepper="8">
        <div className="stepper_content">
          <p className="">
            Paste the copied <b>Secret Code</b> and press the <b>Login</b> button.
          </p>
          <img src="/images/broker_setup_guide/finvasia/step_6.png" alt="Create New App" />
        </div>
      </li>
    </div>
  </div>
);

export default Finvasia;
